// Chargers translations for React Admin resource
export const chargersResource = {
  name: '充電樁',
  fields: {
    id: 'ID',
    name: '名稱',
    siteId: '場地',
    loadGroupId: '負載組',
    model: '型號',
    serialNumber: '序號',
    ocppVersion: 'OCPP 版本',
    status: '狀態',
    power: '功率顯示',
    maxPower: '最大功率 (kW)',
    maxCurrent: '最大電流 (A)',
    numberPhases: '相位數',
    numberPhasesOne: '1（單相）',
    numberPhasesThree: '3（三相）',
    currentPower: '目前功率 (kW)',
    connectorType: '連接器類型',
    connectorCount: '連接器數量',
    connectors: '連接器',
    maxSimultaneousConnectors: '最大同時充電數',
    connectorId: '連接器編號',
    chargerType: '充電器類型',
    firmwareVersion: '韌體版本',
    ocppStatus: 'OCPP 狀態',
    errorCode: '錯誤碼',
    physicalLocation: '實際位置',
    bayNumber: '車位編號',
    zone: '區域',
    qrCode: '手動輸入碼',
    notes: '備註',
    lastStatusUpdate: '最後狀態更新',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    site: '場地',
    stationId: '站點 ID',
    authUsername: '認證用戶名',
    authPassword: '認證密碼',
    authEnabled: '啟用認證',
    ocppTemplateId: 'OCPP 範本',
    noTemplate: '無範本',
    image: '充電樁圖片',
    smartChargingConfig: {
      title: '智能充電能力',
      description: '此充電樁透過 OCPP GetConfiguration 回報的能力參數。LMS 依此決定要傳送一般、合併插槽或不傳送充電設定檔。',
      maxStackLevel: '最大堆疊層級',
      supportedFeatureProfiles: '支援的功能配置',
      chargingRateUnits: '允許的充電率單位',
      maxPeriods: '最大排程週期數',
      maxProfilesInstalled: '最大安裝設定檔數',
      phaseSwitchSupported: '支援三相轉單相切換',
      firmwareVersionAtQuery: '查詢時的韌體版本',
      queriedAt: '最後查詢時間',
      notYetQueried: '尚未查詢。OCPP 伺服器將於充電樁下次連線時查詢,或按「重新整理」立即查詢。',
      refreshButton: '重新整理',
      refreshing: '正在查詢…',
      refreshSuccess: '智能充電能力已更新',
      refreshFailed: '更新智能充電能力失敗',
    },
  },
};

// Custom chargers translations for components
export const chargers = {
  // 充電樁層級狀態 — 一個充電樁可有多個連接器,所以這是匯總狀態。
  // "在線"表示"可連線",與 OCPP 連接器的"Available"語意不同。
  statuses: {
    available: '在線',
    charging: '充電中',
    error: '錯誤',
    maintenance: '維護中',
    offline: '離線',
    unavailable: '不可用',
    faulted: '故障',
    suspended: '暫停',
    suspended_ev: '暫停（電動車）',
    suspended_evse: '暫停（充電器）',
    finishing: '結束中',
    reserved: '已預約',
    preparing: '準備中',
    in_use: '使用中',
  },
  // 每個連接器的 OCPP 1.6 狀態 (ConnectorStatusEnumType)。必須嚴格遵從
  // OCPP 標準 — 不能像上方的充電樁層級狀態那樣把 'available' 翻成 "在線"。
  // Keys 由 ChargersShow.tsx 的 getConnectorStatusKey() 正規化為 lower_snake_case。
  connectorStatuses: {
    available: '可用',
    preparing: '準備中',
    charging: '充電中',
    suspended_ev: '暫停（電動車）',
    suspended_evse: '暫停（充電器）',
    finishing: '結束中',
    reserved: '已預約',
    unavailable: '不可用',
    faulted: '故障',
    // 非 OCPP 標準但可能出現的本地狀態:
    offline: '離線',
    occupied: '使用中',
  },
  list: {
    title: '充電樁',
    filters: {
      search: '按名稱、型號或序號搜尋',
      site: '場地',
      status: '狀態',
      connectorType: '連接器類型',
      ocppVersion: 'OCPP 版本',
    },
  },
  create: {
    title: '建立充電樁',
    subtitle: '添加新的電動車充電樁到網路',
    infoMessage: '建立新的電動車充電樁。請確保在繼續之前已選擇正確的場地和負載組。',
    basicInfo: '基本資訊',
    image: '充電樁圖片',
    imageHelperText: '上傳充電樁圖片以在手機應用程式中顯示',
    locationAssignment: '位置分配',
    technicalSpecs: '技術規格',
    ocppConfig: 'OCPP 配置',
    statusConfig: '狀態配置',
    identification: '識別',
    translations: '多語言翻譯',
    additionalInfo: '附加資訊',
    nameHelperText: '充電樁的描述性名稱',
    modelHelperText: '充電樁型號（例如：Tesla Supercharger V3）',
    serialHelperText: '製造商序號（選填）',
    siteHelperText: '選擇此充電樁所在的場地',
    loadGroupHelperText: '選擇用於電源管理的負載組',
    selectSiteFirst: '請先選擇場地以查看可用的負載組',
    physicalLocationHelperText: '場地內的具體實際位置（例如：第1區、北側）',
    bayNumberHelperText: '付款亭及收據上顯示的車位編號（場地內不可重複）',
    bayNumberRequiredHelperText: '必填：此場地設有付款亭，沒有編號的充電樁不會在付款亭顯示。編號會列印在付款亭及收據上（場地內不可重複）',
    zoneHelperText: '付款亭上顯示的區域名稱，例如「B2 北面」',
    maxPowerHelperText: '最大功率輸出（kW）',
    maxCurrentHelperText: '最大電流（安培）',
    maxCurrentHelperTextWithSuggestion: '最大電流（建議值：%{suggested}）',
    numberPhasesHelperText: '單相充電器（通常 ≤ 7.4 kW）設為 1；三相設為 3。在單相負載群組中將強制為 1。',
    numberPhasesForcedSingle: '已強制為 1，因為所選負載群組為單相。',
    autoCalculated: '根據功率和連接器類型自動計算',
    clickToAutoCalculate: '點擊自動計算電流',
    powerDisplayHelperText: '顯示的功率額定值（例如："150kW 直流快速充電"）',
    connectorTypeHelperText: '充電連接器類型',
    connectorCountHelperText: '充電連接器數量',
    maxSimultaneousConnectorsHelperText: '可同時充電的連接器數量（1 = 同一時間只有一個連接器可充電）',
    ocppVersionHelperText: 'OCPP 協議版本',
    ocppTemplateHelperText: '選擇 OCPP 配置範本（選填）',
    firmwareHelperText: '當前韌體版本（選填）',
    stationIdHelperText: 'OCPP 連接的唯一站點標識符（例如：CS-TESLA-001）',
    authEnabledHelperText: '為 OCPP 連接啟用 HTTP 基本認證',
    authUsernameHelperText: 'OCPP 認證用戶名（例如：CS-TESLA）',
    authPasswordHelperText: 'OCPP 認證密碼',
    statusHelperText: '當前運行狀態',
    ocppStatusHelperText: 'OCPP 特定狀態（選填）',
    errorCodeHelperText: '錯誤代碼（如適用，選填）',
    qrCodeHelperText: '留空以自動生成，或輸入 4 個字元（例如：A3K9）',
    notesHelperText: '關於此充電樁的附加備註',
    additionalInfoMessage: '建立充電樁後可以配置其他設置和資訊。',
    backToList: '返回充電樁列表',
  },
  edit: {
    title: '編輯充電樁',
    basicInfo: '基本資訊',
    image: '充電樁圖片',
    imageHelperText: '上傳或更改在手機應用程式中顯示的充電樁圖片',
    locationAssignment: '位置分配',
    technicalSpecs: '技術規格',
    ocppConfig: 'OCPP 配置',
    statusManagement: '狀態管理',
    chargerReports: '充電器回報',
    autoSyncing: '從充電器自動同步',
    manualOverrideActiveMessage: '手動覆蓋已啟用 - OCPP 更新不會改變狀態',
    overrideSet: '覆蓋設定時間',
    statusEffective: '有效',
    identification: '識別',
    translations: '多語言翻譯',
    additionalInfo: '附加資訊',
    rebootCharger: '重啟充電樁',
    rebootDescription: '透過 OCPP Reset 命令遠端重啟此充電樁。如果充電樁無回應或需要重新啟動時使用。',
    chargerOfflineWarning: '此充電樁目前離線。無法發送重啟命令。',
    deleteCharger: '刪除充電樁',
    deleteChargerDescription: '永久刪除此充電樁及所有相關數據',
    cannotDeleteWithActiveSessions: '無法刪除有活躍充電時段的充電樁',
    connectors: '連接器',
    addConnector: '添加連接器',
    editConnector: '編輯連接器',
    noConnectors: '此充電樁未配置連接器。添加連接器以啟用充電。',
    chargerTypeHelperText: '選擇此連接器的充電器類型類別',
    nameHelperText: '充電樁的描述性名稱',
    modelHelperText: '充電樁型號（例如：Tesla Supercharger V3）',
    serialHelperText: '製造商序號',
    siteHelperText: '此充電樁所在的場地',
    loadGroupHelperText: '用於電源管理的負載組',
    selectSiteFirst: '請先選擇場地以查看可用的負載組',
    physicalLocationHelperText: '場地內的具體實際位置',
    bayNumberHelperText: '付款亭及收據上顯示的車位編號（場地內不可重複）',
    bayNumberRequiredHelperText: '必填：此場地設有付款亭，沒有編號的充電樁不會在付款亭顯示。編號會列印在付款亭及收據上（場地內不可重複）',
    zoneHelperText: '付款亭上顯示的區域名稱，例如「B2 北面」',
    maxPowerHelperText: '最大功率輸出（kW）',
    maxCurrentHelperText: '最大電流（安培）',
    maxCurrentHelperTextWithSuggestion: '最大電流（建議值：%{suggested}）',
    numberPhasesHelperText: '單相充電器（通常 ≤ 7.4 kW）設為 1；三相設為 3。在單相負載群組中將強制為 1。',
    numberPhasesForcedSingle: '已強制為 1，因為所選負載群組為單相。',
    autoCalculated: '根據功率和連接器類型自動計算',
    clickToAutoCalculate: '點擊自動計算電流',
    powerDisplayHelperText: '顯示的功率額定值',
    connectorTypeHelperText: '充電連接器類型',
    connectorCountHelperText: '充電連接器數量',
    maxSimultaneousConnectorsHelperText: '可同時充電的連接器數量（1 = 同一時間只有一個連接器可充電）',
    ocppVersionHelperText: 'OCPP 協議版本',
    ocppTemplateHelperText: '選擇 OCPP 配置範本（選填）',
    firmwareHelperText: '當前韌體版本',
    stationIdHelperText: 'OCPP 連接的唯一站點標識符',
    authEnabledHelperText: '啟用/停用 OCPP 連接的 HTTP 基本認證',
    authUsernameHelperText: 'OCPP 認證用戶名',
    authPasswordHelperText: 'OCPP 認證密碼（留空以保留現有密碼）',
    statusHelperText: '當前運行狀態',
    statusEffectiveHelperText: '這是向用戶顯示的狀態。更改此狀態將啟用手動覆蓋。',
    reservationEnabledLabel: '可供預約',
    reservationEnabledHelperText: '關閉時，此充電樁將被排除於預約池外，與 OCPP 狀態無關。用於長期停用或不希望開放預約的充電樁。',
    manualOverrideActive: '手動覆蓋已啟用',
    manualOverrideHelperText: '開啟時，狀態不會從充電器自動同步',
    manualOverrideReason: '手動覆蓋原因',
    manualOverrideReasonPlaceholder: '例如：計劃維護至下午5點、網絡中斷',
    manualOverrideReasonHelperText: '解釋為何設置手動狀態（僅管理員可見）',
    chargerReportedStatusLabel: '充電器回報狀態（OCPP）',
    chargerReportedStatusHelperText: '唯讀：充電器硬體透過 OCPP 回報的狀態',
    errorCodeLabel: '錯誤碼',
    errorCodeHelperText: 'OCPP 錯誤碼（如有）',
    ocppStatusHelperText: 'OCPP 特定狀態',
    qrCodeHelperText: '留空以自動生成，或輸入 4 個字元（例如：A3K9）',
    notesHelperText: '關於此充電樁的附加備註',
    additionalInfoMessage: '查看充電樁配置並進行必要的調整。',
    backToList: '返回充電樁列表',
    deleteConfirmTitle: '刪除充電樁',
    deleteConfirmWarning: '警告：此操作無法撤銷。',
    deleteConfirmMessage: '您即將刪除充電樁',
    deleteConfirmInfo: '所有相關數據將被永久刪除。',
    deleteConfirmPrompt: '要確認刪除，請輸入充電樁名稱',
    deleteConfirmPromptBelow: '在下方：',
    deleteConfirmTypePlaceholder: '輸入「%{name}」以確認',
    nameDoesNotMatch: '充電樁名稱不匹配',
    deleteButton: '刪除充電樁',
  },
  actions: {
    uploadImage: '上傳圖片',
    changeImage: '更換圖片',
    uploading: '上傳中',
    reboot: '重啟充電樁',
  },
  show: {
    statusInformation: '狀態資訊',
    chargerReportedStatus: '充電器回報狀態（OCPP）',
    metadata: '其他資料',
    created: '建立時間',
    lastUpdated: '最後更新',
    display: '顯示',
    noRebootHistory: '此充電器沒有重啟歷史記錄。',
  },
  notifications: {
    createSuccess: '充電樁創建成功',
    updateSuccess: '充電樁更新成功',
    deleteSuccess: '充電樁刪除成功',
    deleteError: '刪除充電樁時發生錯誤',
    imageUploaded: '圖片上傳成功',
    imageRemoved: '圖片已移除',
    rebootSuccess: '重啟命令發送成功',
  },
  errors: {
    invalidImageType: '無效的圖片類型。請上傳 JPG、PNG 或 WebP 圖片。',
    uploadFailed: '圖片上傳失敗。請重試。',
  },
  multilang: {
    nameHelperText: '充電樁在不同語言中的名稱',
    locationHelperText: '充電樁位置的本地化描述',
    notesHelperText: '以當地語言提供的附加資訊或說明',
  },
  validation: {
    bayNumberRequiredForKiosk: '設有付款亭的場地必須填寫編號',
  },
};